import { useState, useEffect } from "react";
import { REVIEWS } from "../data/content";
import { getReviews } from "../lib/api";

const curated = REVIEWS.map((r) => ({ name: r.name, sub: r.origin, rating: r.rating, text: r.text, url: null }));

// Shared live Google reviews loader used by ReviewsSlideshow and GuideReviews.
export function useLiveReviews() {
  const [items, setItems] = useState(curated);
  const [rating, setRating] = useState("5.0");
  const [placeUrl, setPlaceUrl] = useState(null);
  const [live, setLive] = useState(false);

  useEffect(() => {
    let active = true;
    getReviews()
      .then((data) => {
        if (!active || !data?.available || !data.reviews?.length) return;
        setItems(
          data.reviews.map((r) => ({
            name: r.author_name || "Google reviewer",
            sub: r.relative_time || "",
            rating: r.rating || 5,
            text: r.text,
            url: r.google_maps_uri || r.author_url || null,
          }))
        );
        if (data.rating) setRating(Number(data.rating).toFixed(1));
        setPlaceUrl(data.google_maps_uri || null);
        setLive(true);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return { items, rating, placeUrl, live };
}
